import { useFormContext, useController } from "react-hook-form";
import {
  useFieldProps,
  FieldBaseProps,
} from "@shared/features/form/useFieldProps";
import { OrgLookupYearComboInput } from "./OrgLookupYearComboInput";

export type OrgExperienceInputsProps = FieldBaseProps & {
  name: string;
  maxItems?: number;
  minItems?: number;
};

export function OrgExperienceInputs({
  name,
  required = false,
  maxItems = 3,
  minItems = 1,
  error,
  isLoading,
  isSubmitting,
  className,
}: OrgExperienceInputsProps) {
  const form = useFormContext();

  useController({
    name,
    control: form.control,
    defaultValue: [],
    rules: {
      validate: (entries: any[]) => {
        const filled = entries.filter((entry) => entry?.organization).length;
        if (required && filled < minItems) {
          return `Please add at least ${minItems} organization${
            minItems > 1 ? "s" : ""
          }`;
        }
        return true;
      },
    },
  });

  const fieldProps = useFieldProps({
    className,
    error,
    isLoading,
    isSubmitting,
    required,
  });

  return (
    <div {...fieldProps} className="flex flex-col gap-6">
      {Array.from({ length: maxItems }).map((_, i) => (
        <OrgLookupYearComboInput key={i} namePrefix={`${name}.${i}`} />
      ))}
    </div>
  );
}

export default OrgExperienceInputs;
